/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M1.5185 20.2361c.0281.1851.0858.3647.1728.5279.277.5035.7061.8063 1.2094.8674l.192.0115h17.7785c.5954 0 1.1139-.3178 1.416-.9048.2483-.4325.2793-.9638.0863-1.433l-.0964-.1968-8.8584-15.8904c-.3139-.5467-.8307-.8608-1.416-.8608-.5204 0-.9865.2482-1.297.6748l-.109.1682-8.8785 15.926c-.119.2073-.1893.4405-.2117.6779a1.7752 1.7752 0 0 0 .012.4321ZM14.6964 2.376l8.8685 15.9082c.5801 1.0107.5801 2.2851 0 3.2959-.4973.9735-1.4184 1.5726-2.4372 1.6591l-.2565.0108H3.0927c-1.1189 0-2.1135-.6152-2.6937-1.6699a3.4103 3.4103 0 0 1-.365-1.1287 3.5029 3.5029 0 0 1-.0221-.7754 3.3764 3.3764 0 0 1 .305-1.1541l.1236-.2377L9.309 2.376C9.889 1.3652 10.8837.75 12.0027.75c1.0328 0 1.9597.5242 2.5526 1.3998l.1411.2262ZM12 14.25s.75-.075.75-.75l.75-5.25c0-.8284-.6716-1.5-1.5-1.5s-1.5.6716-1.5 1.5l.75 5.25c0 .675.75.75.75.75ZM13.5 18c0-.8284-.6716-1.5-1.5-1.5s-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5 1.5-.6716 1.5-1.5Z"
    clipRule="evenodd"
  />,
  'Warning'
);
